module.exports = __webpack_public_path__ + "img/chair2.378c9291.png";